// Auto-generated from server/src/Sales.Domain/Constants/AppointmentTypeConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const AppointmentTypeDataConstants = {
  Business: 'b2c3d4e5-f6a7-8901-bcde-f23456789012',
  Initial: 'c3d4e5f6-a7b8-9012-cdef-345678901234',
  InsideSalesRevisit: 'd4e5f6a7-b8c9-0123-defa-456789012345',
  Reset: 'e5f6a7b8-c9d0-1234-efab-567890123456',
  Revisit: 'f6a7b8c9-d0e1-2345-fabc-678901234567',
  ProactiveService: 'a7b8c9d0-e1f2-3456-abcd-789012345678',
  ReactiveService: 'b8c9d0e1-f2a3-4567-bcde-890123456789',
  MoistureControl: 'c9d0e1f2-a3b4-5678-cdef-901234567890',
  RealEstateSellerAppointment: 'd0e1f2a3-b4c5-6789-def0-012345678901',
  RealEstateBuyerAppointment: 'e1f2a3b4-c5d6-7890-ef01-123456789012',
  PrepaidServiceAgreement: 'f2a3b4c5-d6e7-8901-f012-234567890123',
  VirtualAppointment: 'a3b4c5d6-e7f8-9012-0f12-345678901234'
} as const;
